import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import Home from "./component";
import LoadingSpinner from "../Loading/component";

const HomeContainer = (props) => {
  const [loading, setLoading] = useState(false);

  // You can add any API calls here if needed
  useEffect(() => {
    // Example: fetch dashboard data
    // props.getDataFromAPI("/dashboard/api/v2/admin/dashboard", "GET", {}, 
    //   (response) => {
    //     console.log("Dashboard data:", response);
    //     setLoading(false);
    //   },
    //   (error) => {
    //     console.error("Error fetching dashboard:", error);
    //     setLoading(false);
    //   }
    // );
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return <Home />;
};

function mapStateToProps({ app }) {
  return {
    app,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(HomeContainer);